import { render, staticRenderFns } from "./BCSelCallListSettings.vue?vue&type=template&id=56957f93"
import script from "./BCSelCallListSettings.vue?vue&type=script&lang=js"
export * from "./BCSelCallListSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports